let screenFilterTarget = null;
let sceneFilters = [];
let overlayFilters = [];

const applyScreenFilters = () => {
	if(!screenFilterTarget) return;
	const filters = [...sceneFilters, ...overlayFilters];
	screenFilterTarget.filters = filters.length ? filters : null;
};

export const initScreenFilterTarget = target => {
	if(screenFilterTarget && screenFilterTarget !== target) {
		screenFilterTarget.filters = null;
	}
	screenFilterTarget = target || null;
	applyScreenFilters();
};

export const hasScreenFilterTarget = () => Boolean(screenFilterTarget);
export const getScreenFilterArea = () => screenFilterTarget?.filterArea;

export const addScreenFilter = filter => {
	if(!filter || sceneFilters.includes(filter)) return;
	sceneFilters = [...sceneFilters, filter];
	applyScreenFilters();
};

export const removeScreenFilter = filter => {
	if(!sceneFilters.includes(filter)) return;
	sceneFilters = sceneFilters.filter(candidate => candidate !== filter);
	applyScreenFilters();
};

// Overlay filters always render after ordinary screen effects, even if an
// explosion or another transient filter is added later. Portal refraction uses
// this lane so the bend remains the final, depth-independent screen treatment.
export const addScreenOverlayFilter = filter => {
	if(!filter || overlayFilters.includes(filter)) return;
	overlayFilters = [...overlayFilters, filter];
	applyScreenFilters();
};

export const removeScreenOverlayFilter = filter => {
	if(!overlayFilters.includes(filter)) return;
	overlayFilters = overlayFilters.filter(candidate => candidate !== filter);
	applyScreenFilters();
};
